import peptideQuestions, { PeptideQuestionFieldAnswers } from './initial/questions';

const PeptideQuestions = [...peptideQuestions];
export default PeptideQuestions;

export type { PeptideQuestionFieldAnswers };
